/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@root/components/Button';
import dayjs from 'dayjs';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import SafeAreaInset from '@root/components/SafeAreaInset';
import Empty from '@root/components/Empty';
import { DATE_FORMAT } from '@root/constant';
import usePromotions from '@root/hooks/usePromotions';
import SubscribeBg from '@root/assets/discount_activity.png';
import SubscribeCloud from '@root/assets/subscribe_cloud.png';
import SubscribeIpc from '@root/assets/subscribe_ipc.png';
import './index.less';

// 这个页面不需要多语言
const PromotionsPackage = () => {
  const { t } = useTranslation();
  const {
    selectedPrice,
    loading,
    curPackage,
    activityInfo,
    getPackageData,
    onClickPay,
  } = usePromotions();

  const isInit = !curPackage.goodsId;

  if (isInit && loading < 1) {
    return <PageLoading />;
  }

  if (isInit && loading === 2) {
    return <PageLoadError onTryAgain={getPackageData} />;
  }

  if (isInit) {
    return <Empty marginTop={20}>{t('no_data')}</Empty>;
  }

  return (
    <>
      <div className="flex-section-auto default-package-container activity">
        <div className="activity-card">
          <div className="activity-card-bg">
            <div className="activity-card-bg-mask"></div>
          </div>
          <div className="activity-card-content">
            <h1>70% Off</h1>
            <p className="activity-time">
              Limited{' '}
              {activityInfo.startTime
                ? dayjs(activityInfo.startTime).format(DATE_FORMAT)
                : ''}
              ~
              {activityInfo.endTime
                ? dayjs(activityInfo.endTime).format(DATE_FORMAT)
                : ''}
            </p>
            <div className="activity-price-box">
              <div className="activity-price-bg">
                <img src={SubscribeBg} />
              </div>
              <div className="activity-price">
                <div className="activity-price-item">
                  <div className="image-cloud">
                    <img src={SubscribeCloud} />
                  </div>
                  <div className="item-price">
                    <h4>$35.88</h4>
                    <h3>{selectedPrice?.price}</h3>
                  </div>
                </div>
                <div className="activity-price-item">
                  <div className="image-ipc">
                    <img src={SubscribeIpc} />
                  </div>
                  <div className="item-price">
                    <h4>$29.99</h4>
                    <h3>Free</h3>
                  </div>
                </div>
              </div>
            </div>
            <p className="activity-desc">
              Unleash the Power of the Cloud! <br />
              Join our 12-Month Subscription for just $19.99! and Receive a
              Bonus Brand New Camera Absolutely Free!
            </p>
            <h2>Experience the Future of Security!</h2>
            <h2>Receive a Brand New Smart Security Camera!</h2>
            <h6>All Sales are Final. No refunds.</h6>
            <Button onClick={onClickPay}>Purchase</Button>
          </div>
        </div>
      </div>
      <div className="flex-section-footer">
        <Button onClick={onClickPay}>Purchase</Button>
        <SafeAreaInset />
      </div>
    </>
  );
};

export default PromotionsPackage;
